"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Text = exports.ViewContainer = void 0;
const native_1 = __importStar(require("styled-components/native"));
const alignment = (align) => {
    if (align === 'center') {
        return 'center';
    }
    if (align === 'right') {
        return 'right';
    }
    return 'left';
};
const ContainerStyle = native_1.css `
  align-items: center;
  justify-content: center;
  flex-shrink: 1;
`;
exports.ViewContainer = native_1.default.View(() => [ContainerStyle]);
const TextStyle = native_1.css `
  display: flex;
  align-items: center;
  text-align: ${({ align }) => alignment(align)};
  color: ${({ theme, color }) => color || theme.text.color.primary};
`;
const textTypeSwitch = ({ type, theme, }) => {
    switch (type) {
        case 'h1':
            return native_1.css `
        font-size: ${theme.text.h1.fontSize};
        line-height: ${theme.text.h1.lineHeight};
      `;
        case 'h2':
            return native_1.css `
        font-size: ${theme.text.h2.fontSize};
        line-height: ${theme.text.h2.lineHeight};
      `;
        case 'h3':
            return native_1.css `
        font-size: ${theme.text.h3.fontSize};
        line-height: ${theme.text.h3.lineHeight};
      `;
        case 'h4':
            return native_1.css `
        font-size: ${theme.text.h4.fontSize};
        line-height: ${theme.text.h4.lineHeight};
        text-decoration: ${theme.text.h4.textDecoration};
      `;
        case 'small':
            return native_1.css `
        font-size: ${theme.text.small.fontSize};
        line-height: ${theme.text.small.lineHeight};
      `;
        case 'paragraph':
            return native_1.css `
        font-size: ${theme.text.paragraph.fontSize};
        line-height: ${theme.text.paragraph.lineHeight};
      `;
        case 'card-title':
            return native_1.css `
        font-size: ${theme.card.title.size};
        line-height: ${theme.card.title.lineHeight};
      `;
        case 'card-text':
            return native_1.css `
        font-size: ${theme.card.text.size};
        line-height: ${theme.card.text.lineHeight};
      `;
        case 'card-text-pressable':
            return native_1.css `
        line-height: ${theme.card.textPressable.lineHeight};
        font-size: ${theme.card.textPressable.size};
        padding: 13px 0 13px 34px;
      `;
        case 'card-text-light':
            return native_1.css `
        color: ${theme.text.color.secondary};
        font-size: ${theme.card.text.size};
      `;
        case 'card-text-primary':
            return native_1.css `
        color: ${theme.text.color.tertiary};
      `;
        case 'card-text-small':
            return native_1.css `
        font-size: ${theme.card['text-small'].size};
        line-height: ${theme.card['text-small'].lineHeight};
      `;
        case 'card-text-medium':
            return native_1.css `
        font-size: ${theme.card['text-medium'].size};
        line-height: ${theme.card['text-medium'].lineHeight};
      `;
        case 'card-text-large':
            return native_1.css `
        font-size: ${theme.card['text-large'].size};
        line-height: ${theme.card['text-large'].lineHeight};
      `;
        case 'card-text-xxl':
            return native_1.css `
        font-size: ${theme.card['text-xxl'].size};
        line-height: ${theme.card['text-xxl'].lineHeight};
      `;
        case 'card-text-xl':
            return native_1.css `
        font-size: ${theme.card['text-xl'].size};
        line-height: ${theme.card['text-xl'].lineHeight};
      `;
        case 'start-charge-link':
            return native_1.css `
        color: #000096;
        font-size: 16px;
      `;
        default:
            return '';
    }
};
exports.Text = native_1.default.Text(({ type, onPress, theme, weight }) => {
    return [
        TextStyle,
        textTypeSwitch({ type, theme }),
        onPress && `color: ${theme.text.color.tertiary};`,
        weight && `font-weight: ${weight}`,
    ];
});
